import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function EmptyState({ text, onClick = () => {} }) {
  return (
    <Text
      color="blue"
      onClick={onClick}
      size="md"
      sx={{
        cursor: 'pointer'
      }}
    >
      {text}
    </Text>
  );
}

EmptyState.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
